
import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class BettingService {

    constructor(
        private httpService: HttpService) { }

    //获取彩票所需要的所有数据
    //TQQ 2017-01-06
    getLottery(lotteryCode) {
        let url = AppConfig.GetProdUrl() + "/Lottery/GetLottery?lotteryCode=" + lotteryCode;
        return this.httpService.get(url);
    }

    //获取当前期号，上期期号，当前期号结束剩余时间
    //TQQ 2017-01-06
    getIssue(lotteryCode) {
        let url = AppConfig.GetProdUrl() + "/Lottery/GetIssue?lotteryCode=" + lotteryCode;
        return this.httpService.get(url);
    }

    //获取彩票开奖历史
    //TQQ 2017-01-06
    getHistory(lotteryCode) {
        let url = AppConfig.GetProdUrl() + "/Lottery/GetHistory?lotteryCode=" + lotteryCode;
        return this.httpService.get(url);
    }

    //投注
    //TQQ 2017-01-10
    betting(order) {
        let url = AppConfig.GetProdUrl() + "/Lottery/Betting";
        return this.httpService.post(url, order);
    }

    //信用玩法投注
    dollarBetting(order) {
        let url = AppConfig.GetProdUrl() + "/Lottery/KQWFBetting";
        return this.httpService.post(url, order);
    }

    //获取信用玩法明细
    getDollarDetaile(lotteryCode) {
        let url = AppConfig.GetProdUrl() + "/Lottery/GetSMPPlayMode?lotteryCode=" + lotteryCode;
        return this.httpService.get(url);
    }

    //获取玩法明细
    //TQQ 2017-02-16
    getPlayDetail(detailcode: string) {
        let url = AppConfig.GetProdUrl() + "/Lottery/GetPlayDetail?playDetailCode=" + detailcode;
        return this.httpService.get(url);
    }

}


// WEBPACK FOOTER //
// ./src/services/betting.service.ts